export const STRICT_PASSWORD_POLICY = {
    minLength: 10,
    maxLength: 128,
    requiredCategories: 3,
};
export const WEAK_PASSWORD_POLICY = {
    minLength: 6,
    maxLength: 128,
    requiredCategories: 0,
};
export const getPasswordPolicy = (allowWeakPasswords) => {
    return isWeakPasswordModeEnabled(allowWeakPasswords)
        ? WEAK_PASSWORD_POLICY
        : STRICT_PASSWORD_POLICY;
};
export const isWeakPasswordModeEnabled = (allowWeakPasswords) => {
    if (typeof allowWeakPasswords === 'boolean') {
        return allowWeakPasswords;
    }
    return allowWeakPasswords?.toLowerCase() === 'true';
};
export const countPasswordCategories = (password) => {
    const categories = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/];
    return categories.filter((pattern) => pattern.test(password)).length;
};
export const validatePasswordAgainstPolicy = (password, policy) => {
    const categoryCount = countPasswordCategories(password);
    const hasMinLength = password.length >= policy.minLength;
    const hasMaxLength = password.length <= policy.maxLength;
    const meetsCategoryRequirement = categoryCount >= policy.requiredCategories;
    return {
        isValid: hasMinLength && hasMaxLength && meetsCategoryRequirement,
        hasMinLength,
        hasMaxLength,
        categoryCount,
        meetsCategoryRequirement,
    };
};
//# sourceMappingURL=password-policy.js.map